import type { ListMediaParams, ListLinksParams } from '@/types/api';

/**
 * Centralised query keys. Keeping them here means invalidation after a mutation can never
 * drift from the key a query registered under.
 */
export const queryKeys = {
  all: ['slc'] as const,

  // Keyed on auth state: `/me` answers differently for an anonymous caller than a signed-in
  // one, so a single key would serve a cached anonymous profile to a user who just signed in.
  me: (authenticated: boolean) =>
    [...queryKeys.all, 'me', authenticated ? 'auth' : 'anon'] as const,

  links: () => [...queryKeys.all, 'links'] as const,
  linkList: (params: ListLinksParams) => [...queryKeys.links(), 'list', params] as const,
  linkDetail: (linkId: string) => [...queryKeys.links(), 'detail', linkId] as const,

  categories: () => [...queryKeys.all, 'categories'] as const,

  facets: () => [...queryKeys.all, 'facets'] as const,
  facet: (kind: 'users' | 'channels' | 'domains') => [...queryKeys.facets(), kind] as const,

  adminFailures: () => [...queryKeys.all, 'admin', 'failures'] as const,

  stats: () => [...queryKeys.all, 'stats'] as const,

  settings: () => [...queryKeys.all, 'settings'] as const,
  mediaChannelOptions: () => [...queryKeys.settings(), 'media-channels'] as const,

  media: () => [...queryKeys.all, 'media'] as const,
  mediaList: (params: ListMediaParams) => [...queryKeys.media(), 'list', params] as const,
  mediaFacets: () => [...queryKeys.media(), 'facets'] as const,
};
